export const ServiceOptions = [
   
    { value: 'Submitted', label: 'Submitted'},
    { value: 'Approved', label: 'Approved'},
    { value: 'On Hold', label: 'On Hold' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'With Qualification', label: 'With Qualification' },
  
]